"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useRecommendationHandsets = require("../../hooks/recommendation/useRecommendationHandsets");
var _services = require("../../services");
var _useRecommendationTabs = require("../../hooks/recommendation/useRecommendationTabs");
var _ProductCard = _interopRequireDefault(require("./ProductCard/ProductCard"));
var _useDynamicPageContent = _interopRequireDefault(require("../../hooks/dynamic/useDynamicPageContent"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RecommendationTabs = function RecommendationTabs() {
  var _useRecommendationHan = (0, _useRecommendationHandsets.useRecommendationHandsets)(),
    recommendedHandset = _useRecommendationHan.recommendedHandset,
    premiumHandset = _useRecommendationHan.premiumHandset,
    budgetHandset = _useRecommendationHan.budgetHandset,
    alternativePremiumHandset = _useRecommendationHan.alternativePremiumHandset,
    alternativeBudgetHandset = _useRecommendationHan.alternativeBudgetHandset,
    selectedHandset = _useRecommendationHan.selectedHandset;
  var handsets = [recommendedHandset, premiumHandset, alternativePremiumHandset, alternativeBudgetHandset, budgetHandset].filter(function (handset) {
    return handset;
  });
  var _useRecommendationTab = (0, _useRecommendationTabs.useRecommendationTabs)(),
    onTabSwitch = _useRecommendationTab.onTabSwitch;
  var _useDynamicPageConten = (0, _useDynamicPageContent.default)(),
    setDynamicContentPage = _useDynamicPageConten.setDynamicContentPage;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tabs, {
    tabs: {
      width: 'stretch'
    },
    onTabClick: onTabSwitch,
    externallySetTabId: selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.productId
  }, handsets.map(function (handset, index) {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tab, {
      key: handset.productId,
      text: _services.locale.localeString("Recommendation.".concat(handset.tier)),
      id: handset.productId
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_ProductCard.default, {
      handset: handset,
      handsetIndex: index,
      onFullSpecsShow: function onFullSpecsShow() {
        setDynamicContentPage(_constants.DYNAMIC_PAGES.FULL_SPECS);
      }
    })));
  })));
};
var _default = RecommendationTabs;
exports.default = _default;